import { ref } from 'vue'

const STORAGE_KEY = 'plyas-sidebar-collapsed'

function readStoredCollapsed(): boolean {
  if (typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** Shared collapsed flag so the instrument sidebar can hide/show across the layout. */
const collapsed = ref(readStoredCollapsed())

function persist(value: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, value ? '1' : '0')
  } catch {
    /* private mode / quota */
  }
}

/**
 * Left instrument panel (tab routes): collapse to reclaim horizontal space for the main
 * area, expand to show tabs again. Preference is stored in `localStorage`.
 */
export function useSidebarPanel() {
  function toggle() {
    collapsed.value = !collapsed.value
    persist(collapsed.value)
  }

  function expand() {
    if (collapsed.value) {
      collapsed.value = false
      persist(false)
    }
  }

  function collapse() {
    if (!collapsed.value) {
      collapsed.value = true
      persist(true)
    }
  }

  return { collapsed, toggle, expand, collapse }
}
